module.exports = __webpack_public_path__ + "img/iq.4fd4432a.svg";